import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Button, FormGroup, InputGroup, Switch } from "@blueprintjs/core";
import { IntegrationStore } from "../../stores/xml-integracao/IntegrationStore";
import { toast } from "react-toastify";

@observer
export default class Dominio extends React.Component<{}, {}> {

  obs = observable({})

  constructor(props: {}) {
    super(props);
  }

  async handleSaveToken() {

    if (IntegrationStore.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Você precisa selecionar uma empresa.', {});
      return
    }

    let data = {
      token: IntegrationStore.obs.token_cliente_dominio,
      cnpj: IntegrationStore.obs.selectedEmpresa.cnpj,
      envio_automatico: IntegrationStore.obs.envio_automatico_dominio_api,
      tipo: "dominio"
    }

    await IntegrationStore.handleSaveToken(data)

  }

  handleChangeEnvio = (e) => {

    const newValue = e.target.checked;

    IntegrationStore.obs.envio_automatico_dominio_api = newValue

  };

  render() {

    return (
      <>

        <div style={{ background: "#f5f8fa", borderLeft: "3px solid #2b82bc", padding: "10px 14px", borderRadius: 4, marginTop: 15, marginBottom: 15 }}>
          <p style={{ margin: 0, fontSize: 11, color: "#394b59", lineHeight: 1.6 }}>
            <strong>DOMÍNIO:</strong> integração realizada via <strong>ONVIO</strong>.
          </p>
        </div>

        <FormGroup label="Envio Automático">
          <Switch
            label={IntegrationStore.obs.envio_automatico_dominio_api ? "Ativado" : "Desativado"}
            checked={IntegrationStore.obs.envio_automatico_dominio_api}
            onChange={(e: any) => this.handleChangeEnvio(e)} />
        </FormGroup>

        <FormGroup label="Token cliente Domínio">
          <InputGroup
            style={{ width: 500 }}
            value={IntegrationStore.obs.token_cliente_dominio}
            onChange={(e: any) => IntegrationStore.obs.token_cliente_dominio = e.target.value}
          />
        </FormGroup>

        <Button intent="primary" onClick={() => this.handleSaveToken()}>Salvar configuração</Button>

      </>
    )
  }


}